import styled from 'styled-components';

export const ErrorInfoContainer = styled.div`
  color: ${({ theme }) => theme.COLORS.secondary};
  background-color: ${({ theme }) => theme.COLORS.secondaryLight};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;

  h1 {
    font-size: 6rem;
    margin-bottom: 0.5rem;
    color: ${({ theme }) => theme.COLORS.primary};
  }
`;
